// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"loader_loaderContainer__3yazt","loader":"loader_loader__31U88","spin":"loader_spin__3GevV"};